import type { RouteRecordRaw } from 'vue-router';

export const fileUploaderSandboxRoute: RouteRecordRaw = {
  path: '/sandbox/file-uploader',
  name: 'FileUploaderSandbox',
  component: () => import('./pages/FileUploaderSandbox.vue'),
  meta: {
    layout: 'main',
  },
};

export const imageUploaderSandboxRoute: RouteRecordRaw = {
  path: '/sandbox/image-uploader',
  name: 'ImageUploaderSandbox',
  component: () => import('./pages/ImageUploaderSandbox.vue'),
  meta: {
    layout: 'main',
  },
};

export const phoneInputSandboxRoute: RouteRecordRaw = {
  path: '/sandbox/phone-input',
  name: 'PhoneInputSandbox',
  component: () => import('./pages/PhoneInputSandbox.vue'),
  meta: {
    layout: 'main',
  },
};
